const type = 'SET_AGREEMENT_LOADING';

const setAgreementLoading = () => ({
  type,
});

export { type };
export default setAgreementLoading;
